import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { NewsSpotlight } from '../components/home/NewsSpotlight';
import { EventsCalendar } from '../components/home/EventsCalendar';
import { DiscoverCards } from '../components/home/DiscoverCards';
import { AppPromoBanner } from '../components/home/AppPromoBanner';
interface AccueilProps {
  showEvents?: boolean;
}

/**
 * Page d'accueil reconstruite sur la structure réelle de beaconsfield.ca.
 *
 * Chaque section gère sa propre largeur : `main` n'a pas de conteneur global, pour que le
 * hero et « Quoi de neuf? » puissent occuper toute la largeur sans astuce de marge
 * négative — celle-ci provoque un défilement horizontal dès qu'une barre est affichée.
 */
export function Accueil({
  showEvents = true
}: AccueilProps) {
  return <main data-id="element-2878" data-mp="27khwtj566owb">
      <HomeHero data-id="element-2879" data-mp="27k9lvwslxtnr" />
      <NewsSpotlight data-id="element-2880" data-mp="27ios49e4aeqy" />
      {showEvents && <EventsCalendar data-id="element-2881" data-mp="27hncrsq2j63f" />}
      <DiscoverCards data-id="element-2882" data-mp="23hv29ah46pvf" />
      <AppPromoBanner data-id="element-2883" data-mp="23jfyr5mzoivx" />
    </main>;
}